import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthProvider';

function LoginForm(props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const {login} = useContext(AuthContext);


  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle login logic, e.g., send data to backend API
    
    try {
      await login(username, password);
      navigate('/jewellery');
    } catch (error) {
      console.error('Login failed:', error);
    }
  }

  const handleForgotPassword = () => {
    console.log("Forgot password clicked");
    navigate('/forgot-password');
  }

  return (
    <div>
    <form onSubmit={handleSubmit}>
      Login
      <div>
      <input
        type="username"
        placeholder="Username"
        value={username}
        className="text-box-style"
        onChange={(e) => setUsername(e.target.value)
        }
      /></div>
      <div>
      <input
        type="password"
        placeholder="Password"
        value={password}
        className="text-box-style"
        onChange={(e) => setPassword(e.target.value)}
      />
      </div>
      <button type="submit">Log In</button><br></br>
    </form>
    <button onClick={handleForgotPassword}>Forgot Password</button>
    </div>
  );
}

export default LoginForm;